<template>
  <div class="d-flex justify-content-between mb-2">
    <div class="pagination-side align-self-center small">全{{ status.total }}件中 {{ status.from }}件～{{ status.to }}件を表示</div>
    <ul v-if="visiblePages.length" class="pagination flex-shrink-0 justify-content-center mb-0">
      <page-item text="前へ" @click="doPrev" :class="{disabled: !canPrev}" />
      <page-item v-for="(visiblePage, key) in visiblePages" :key="key"
                 :class="{active: visiblePage === status.current_page}"
                 :text="visiblePage" @click="$emit('change-page', visiblePage)"
      />
      <page-item text="次へ" @click="doNext" :class="{disabled: !canNext}" />
    </ul>
    <div class="pagination-side justify-content-end">
      <slot />
    </div>
  </div>
</template>

<script>
import PageItem from '@/views/atoms/PageItem';

export default {
  name: "Pagination",
  components: {
    PageItem,
  },
  props: {
    status: {
      type: [Object, null],
      default: null,
    },
  },
  emits: ['change-page', 'change-per-page'],
  data() {
    return {
      startPage: 1,
      endPage: 1,
    }
  },
  computed: {
    visiblePages() {
      let visiblePages = [];
      for (let i = this.startPage; i <= this.endPage; i++) {
        visiblePages.push(i);
      }
      return visiblePages;
    },
    canPrev() {
      return 1 < this.status.current_page;
    },
    canNext() {
      return this.status.current_page < this.status.last_page;
    }
  },
  mounted() {
    [this.startPage, this.endPage] = this.calculateStartEndPage();
  },
  updated() {
    [this.startPage, this.endPage] = this.calculateStartEndPage();
  },
  methods: {
    calculateStartEndPage() {
      // 現在のページを中心に前後2ページずつ表示 ただし、前か後で2ページ表示できない場合はその分反対側に表示枠が増える
      const BOTH_SIDE_PAGE_COUNT = 2;
      let startPage = this.status.current_page - BOTH_SIDE_PAGE_COUNT;
      let endPage = this.status.current_page + BOTH_SIDE_PAGE_COUNT;
      if (startPage < 1) {
        // 左側に枠が足りないケースは、開始は1ページ固定・終了は超えない範囲で＋4ページ
        startPage = 1;
        endPage = Math.min(1 + BOTH_SIDE_PAGE_COUNT * 2, this.status.last_page);
      }
      if (this.status.last_page < endPage) {
        // 右側に枠が足りないケースは、開始は超えない範囲で-4ページ・終了は最終ページ固定
        startPage = Math.max(this.status.last_page - BOTH_SIDE_PAGE_COUNT * 2, 1);
        endPage = this.status.last_page;
      }
      return [startPage, endPage];
    },
    doPrev() {
      if (this.canPrev) {
        this.$emit('change-page', this.status.current_page - 1);
      }
    },
    doNext() {
      if (this.canNext) {
        this.$emit('change-page', this.status.current_page + 1);
      }
    }
  }
}
</script>

<style scoped>
.pagination-side {
  display: flex;
  flex-basis: 50%;
}
</style>
